import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const CompactTableExpandedRow = ({ children }: { children: React.ReactNode }) => {
  return <div css={[styles.flexColumn, styles.expandedRowElement]}>{children}</div>;
};

const styles = {
  flexColumn: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `,
  expandedRowElement: css`
    padding: ${theme.spacing(2)};
  `,
};
